import { Box } from "@mui/system";
import LeftSidebar from "./LeftSidebar";
import MainContent from "./MainContent";
import RightSidebar from "./RightSidebar";
import { Paper, Theme, useMediaQuery, Drawer, IconButton, SvgIcon } from "@mui/material";
import { useState } from "react";
import Bars3Icon from "@heroicons/react/24/outline/Bars3Icon";

const Questions = () => {
  const mdUp = useMediaQuery<Theme>((theme) => theme.breakpoints.up("md"));
  const [showLeftSidebar, setShowLeftSidebar] = useState(false);
  const [showRightSidebar, setShowRightSidebar] = useState(false);

  return (
    <Box display="flex" flexDirection={mdUp ? "row" : "column"} pt={2} gap={2}>
      {/* Always render left sidebar even on mobile to ensure data loads */}
      <Box sx={{ display: mdUp ? "block" : "none" }} flex={mdUp ? 2 : undefined}>
        <Box
          component={Paper}
          elevation={4}
          maxHeight="90vh"
          sx={{ overflowY: "scroll" }}
        >
          <LeftSidebar />
        </Box>
      </Box>

      {/* Mobile drawer view */}
      {!mdUp && (
        <>
          <Drawer
            anchor="left"
            open={showLeftSidebar}
            onClose={() => setShowLeftSidebar(false)}
            PaperProps={{
              sx: {
                width: { xs: "80%", sm: "40%" },
                maxWidth: 400,
              },
            }}
          >
            <LeftSidebar />
          </Drawer>
          <Drawer
            anchor="right"
            open={showRightSidebar}
            onClose={() => setShowRightSidebar(false)}
            PaperProps={{
              sx: {
                width: { xs: "80%", sm: "40%" },
                maxWidth: 400,
              },
            }}
          >
            <RightSidebar />
          </Drawer>
          <Box flex={1} position="relative">
            <Box
              position="absolute"
              top={60}
              left={8}
              zIndex={1}
              component={Paper}
              elevation={2}
            >
              <IconButton
                onClick={() => setShowLeftSidebar(true)}
                sx={{ padding: 1 }}
              >
                <SvgIcon fontSize="small">
                  <Bars3Icon />
                </SvgIcon>
              </IconButton>
            </Box>
            <Box
              position="absolute"
              top={60}
              right={8}
              zIndex={1}
              component={Paper}
              elevation={2}
            >
              <IconButton
                onClick={() => setShowRightSidebar(true)}
                sx={{ padding: 1 }}
              >
                <SvgIcon fontSize="small">
                  <Bars3Icon />
                </SvgIcon>
              </IconButton>
            </Box>
            <MainContent />
          </Box>
        </>
      )}
      
      {/* Desktop view */}
      {mdUp && (
        <>
          <Box flex={4}>
            <MainContent />
          </Box>
          <Box flex={2}>
            <Box
              component={Paper}
              elevation={4}
              maxHeight="90vh"
              sx={{ overflowY: "scroll" }}
            >
              <RightSidebar />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
export default Questions;
